import MainLayout from 'src/layouts';
import { Helmet } from 'react-helmet';
import CalendarBooking from 'src/features/CalendarBooking';

const CalendarBookingPage = () => {
  return (
    <MainLayout>
      <Helmet>
        <title>Calendar booking</title>
      </Helmet>
      <CalendarBooking />
    </MainLayout>
  );
};

export default CalendarBookingPage;
